import { BigNumber } from "bignumber.js";

export const fromUnesToNes = (value: string) => {
  return new BigNumber(value).div(new BigNumber(10).pow(6));
};
